import { Typography, Button, inputClasses, inputLabelClasses, TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
import Comment from "../../assets/icons/Comment.js";
import "react/jsx-runtime";
const CommentsContainer = styled("div")(() => ({
  background: "#EDF8F7",
  borderRadius: "12px",
  padding: "12px 16px 16px"
}));
const CommentsHeader = styled("div")(() => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center"
}));
const CommentsHeading = styled(Typography)(() => ({
  fontFamily: "Lato, sans-serif",
  fontSize: "15px",
  lineHeight: "20px",
  color: "#004734",
  marginBottom: "12px"
}));
const CommentsToggleButton = styled(Button)(() => ({
  fontFamily: "Lato, sans-serif",
  fontSize: "15px",
  lineHeight: "20px",
  color: "#004734",
  textTransform: "none"
}));
const InputWrapper = styled("div")(() => ({
  width: "100%",
  [`.${inputClasses.root}`]: {
    borderColor: "#00725E",
    paddingTop: 16,
    marginTop: 0,
    fontSize: 15,
    fontFamily: "Lato,sans-serif",
    [`&.${inputClasses.error}`]: {
      backgroundColor: "#FEF1F3",
      color: "#B5223B",
      "&:after": {
        borderColor: "#B5223B"
      }
    },
    "&:after, &:before": {
      borderColor: "#00725E"
    }
  },
  [`.${inputClasses.root}:hover:not(.${inputClasses.disabled}):before`]: {
    borderBottom: `2px solid #00725E`
  },
  [`.${inputLabelClasses.root}`]: {
    color: "#00725E",
    fontWeight: 700,
    fontSize: 15,
    marginLeft: 46,
    zIndex: 2,
    marginTop: 6,
    fontFamily: "Lato,sans-serif",
    [`&.${inputLabelClasses.focused}`]: {
      color: "#00725E"
    },
    [`&.${inputLabelClasses.error}`]: {
      color: "#B5223B"
    }
  }
}));
const Input = styled(TextField)(() => ({
  background: "#fff",
  ["& input::placeholder"]: {
    fontSize: "13px"
  }
}));
const CommentIcon = styled(Comment)(() => ({
  marginBottom: "14px",
  marginLeft: "14px",
  color: "#00725E"
}));
const CommentsListContainer = styled("div")(() => ({
  marginTop: "12px"
}));
const CommentWrapper = styled("div")(() => ({
  display: "flex",
  alignItems: "flex-start",
  width: "100%",
  marginBottom: "18px",
  "&:last-of-type": {
    marginBottom: 0
  }
}));
const CommentText = styled(Typography)(() => ({
  fontFamily: "Lato, sans-serif",
  fontWeight: 400,
  fontSize: "13px",
  lineHeight: "16px"
}));
const CommentInfo = styled(Typography)(() => ({
  fontFamily: "Lato, sans-serif",
  fontWeight: 700,
  fontSize: "10px",
  lineHeight: "12px",
  letterSpacing: "0.5px",
  textTransform: "uppercase"
}));
export {
  CommentIcon,
  CommentInfo,
  CommentText,
  CommentWrapper,
  CommentsContainer,
  CommentsHeader,
  CommentsHeading,
  CommentsListContainer,
  CommentsToggleButton,
  Input,
  InputWrapper
};
